import o from "./index823.js";
import r from "./index800.js";
var e = "[object AsyncFunction]", a = "[object Function]", c = "[object GeneratorFunction]", i = "[object Proxy]";
function g(n) {
  if (!r(n))
    return !1;
  var t = o(n);
  return t == a || t == c || t == e || t == i;
}
export {
  g as default
};
